import { InternalWorkoutReview, WorkoutSelection, WorkoutSelectionStatus } from '../../../entities';
import { IExerciseRepository } from '../interfaces/iexercise-repository';
import { IWorkoutSelectionRepository } from '../interfaces/iworkoutselection-repository';

export class DbWorkoutSelectionRepositoryWithLatestExercises implements IWorkoutSelectionRepository {
    constructor(private exerciseRepository: IExerciseRepository,
                private workoutSelectionRepository: IWorkoutSelectionRepository) {
     }

    public async getAll(): Promise<WorkoutSelection[]> {
        const all = await this.workoutSelectionRepository.getAll();
        for (const workoutSelection of all) {
            await this.replaceExercisesWithLatest(workoutSelection);
        }
        return all;
    }

    public async get(uid: string): Promise<WorkoutSelection | undefined> {
        const workoutSelection = await this.workoutSelectionRepository.get(uid);
        if (workoutSelection != null) {
            await this.replaceExercisesWithLatest(workoutSelection);
        }
        return workoutSelection;
    }

    public async add(workoutSelection: WorkoutSelection): Promise<WorkoutSelection> {
        const added = await this.workoutSelectionRepository.add(workoutSelection);
        return await this.getWithExerciseReplaced(added);
    }
    public async update(workoutSelection: WorkoutSelection): Promise<WorkoutSelection> {
        const updated = await this.workoutSelectionRepository.update(workoutSelection);
        return await this.getWithExerciseReplaced(updated);
    }

    public async addReview(workoutId: string, review: InternalWorkoutReview): Promise <void> {
        return this.workoutSelectionRepository.addReview(workoutId, review);
    }

    public async addPowerReview(workoutId: string, review: InternalWorkoutReview): Promise < void > {
        return this.workoutSelectionRepository.addPowerReview(workoutId, review);
    }

    public async filter(status: WorkoutSelectionStatus, from: number, to: number): Promise < WorkoutSelection[] > {
        return this.workoutSelectionRepository.filter(status, from, to);
    }

    private async getWithExerciseReplaced(selection: WorkoutSelection) {
        const retrieved = await this.get(selection.uniqueReference);
        if (retrieved == null) {
            throw Error('Workout selection add failed.');
        }
        return retrieved;
    }

    private async replaceExercisesWithLatest(workoutSelection: WorkoutSelection) {
        for (const exerciseSelection of workoutSelection.exerciseSelections) {
            if (exerciseSelection.exercise != null
                && exerciseSelection.exercise.uniqueReferenceNumber != null) {
                const latestExercise = await this.exerciseRepository.get(
                    exerciseSelection.exercise.uniqueReferenceNumber);
                if (latestExercise != null) {
                    exerciseSelection.exercise = latestExercise;
                } else {
                    throw Error(`Exercise with ref ${
                        exerciseSelection.exercise.uniqueReferenceNumber
                    } was removed from the database but is in a workoutselection: ${workoutSelection.uniqueReference}`);
                }
            }
            if (exerciseSelection.alternateExercise != null
                    && exerciseSelection.alternateExercise.uniqueReferenceNumber != null) {
                const latestAlternateExercise = await this.exerciseRepository.get(
                    exerciseSelection.alternateExercise.uniqueReferenceNumber);
                if (latestAlternateExercise != null) {
                    exerciseSelection.alternateExercise = latestAlternateExercise;
                } else {
                    throw Error(`Exercise with ref ${
                        exerciseSelection.alternateExercise.uniqueReferenceNumber
                    } was removed from the database but is in a workoutselection: ${workoutSelection.uniqueReference}`);
                }
            }
            if (exerciseSelection.secondAlternateExercise != null
                    && exerciseSelection.secondAlternateExercise.uniqueReferenceNumber != null) {
                const latestSecondAlternateExercise = await this.exerciseRepository.get(
                    exerciseSelection.secondAlternateExercise.uniqueReferenceNumber);
                if (latestSecondAlternateExercise != null) {
                    exerciseSelection.secondAlternateExercise = latestSecondAlternateExercise;
                } else {
                    throw Error(`Exercise with ref ${
                        exerciseSelection.secondAlternateExercise.uniqueReferenceNumber
                    } was removed from the database but is in a workoutselection: ${workoutSelection.uniqueReference}`);
                }
            }
            if (exerciseSelection.thirdAlternateExercise != null
                    && exerciseSelection.thirdAlternateExercise.uniqueReferenceNumber != null) {
                const latestThirdAlternateExercise = await this.exerciseRepository.get(
                    exerciseSelection.thirdAlternateExercise.uniqueReferenceNumber);
                if (latestThirdAlternateExercise != null) {
                    exerciseSelection.thirdAlternateExercise = latestThirdAlternateExercise;
                } else {
                    throw Error(`Exercise with ref ${
                        exerciseSelection.thirdAlternateExercise.uniqueReferenceNumber
                    } was removed from the database but is in a workoutselection: ${workoutSelection.uniqueReference}`);
                }
            }
        }
    }

}
